import { useEffect } from 'react';
import SkeletonLoadWrapper from '../../../../components/common/loading/SkeletonLoadWrapper';
import { trackTermSelectorInteraction } from '../../../../v2/utils/tracking/trackingEventUtils';
import { useAnnualDiscountPercentage, useGetAvailableTermsForTermSelector } from '../../../hooks/pricing/useGrowthPurchaseOptions';
import { useQueryParamTerm } from '../../../utils/urls/appQueryParamUtils';
import { BaseTermSelectorComponent } from './BaseTermSelectorComponent';
import { jsx as _jsx } from "react/jsx-runtime";
const getDiscountPercentageToShow = discount => {
  if (!discount) return null;
  return discount === 10 ? discount : null;
};
const DetailedTermSelector = ({
  apiName,
  trackingSource,
  screen
}) => {
  const {
    queryParamTerm: activeTerm,
    setQueryParamTerm
  } = useQueryParamTerm();
  const {
    availableTerms,
    loading: availableTermsLoading,
    shouldShowTermSelector
  } = useGetAvailableTermsForTermSelector({
    productApiName: apiName,
    quantity: 1
  });
  const annualTerm = availableTerms === null || availableTerms === void 0 ? void 0 : availableTerms.annual;
  const monthlyTerm = availableTerms === null || availableTerms === void 0 ? void 0 : availableTerms.monthly;
  const {
    discountPercentage: annualDiscountPercent
  } = useAnnualDiscountPercentage({
    productApiName: apiName,
    quantity: 1
  });
  const discountPercentageToShow = getDiscountPercentageToShow(annualDiscountPercent);
  const hasAnnualDiscount = !!discountPercentageToShow;
  const discountMessage = hasAnnualDiscount ? `${Math.round(discountPercentageToShow)}PercentDiscount` : 'PercentDiscount';
  useEffect(() => {
    if (monthlyTerm && annualTerm) {
      var _selectedTerm$payment, _selectedTerm$commitm;
      const selectedTerm = activeTerm === 'MONTHLY' ? monthlyTerm : annualTerm;
      trackTermSelectorInteraction({
        action: 'view',
        term: activeTerm.toLocaleLowerCase(),
        paymentTerm: selectedTerm === null || selectedTerm === void 0 || (_selectedTerm$payment = selectedTerm.payment) === null || _selectedTerm$payment === void 0 ? void 0 : _selectedTerm$payment.toString(),
        commitTerm: selectedTerm === null || selectedTerm === void 0 || (_selectedTerm$commitm = selectedTerm.commitment) === null || _selectedTerm$commitm === void 0 ? void 0 : _selectedTerm$commitm.toString(),
        trackingSource,
        discountShown: discountMessage,
        screen,
        productNames: apiName ? [apiName] : []
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [monthlyTerm, annualTerm]);
  const onToggleChange = () => {
    if (monthlyTerm && annualTerm) {
      var _selectedTerm$payment2, _selectedTerm$commitm2;
      const newQueryParamTerm = activeTerm === 'MONTHLY' ? 'ANNUAL' : 'MONTHLY';
      const selectedTerm = newQueryParamTerm === 'MONTHLY' ? annualTerm : monthlyTerm;
      setQueryParamTerm(newQueryParamTerm);
      trackTermSelectorInteraction({
        action: 'click',
        term: newQueryParamTerm.toLocaleLowerCase(),
        paymentTerm: selectedTerm === null || selectedTerm === void 0 || (_selectedTerm$payment2 = selectedTerm.payment) === null || _selectedTerm$payment2 === void 0 ? void 0 : _selectedTerm$payment2.toString(),
        commitTerm: selectedTerm === null || selectedTerm === void 0 || (_selectedTerm$commitm2 = selectedTerm.commitment) === null || _selectedTerm$commitm2 === void 0 ? void 0 : _selectedTerm$commitm2.toString(),
        trackingSource,
        discountShown: discountMessage,
        screen,
        productNames: []
      });
    }
  };
  if (!shouldShowTermSelector || !availableTerms) {
    return null;
  }
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: availableTermsLoading,
    heights: [54],
    widths: [190],
    children: /*#__PURE__*/_jsx(BaseTermSelectorComponent, {
      onToggleChange: onToggleChange,
      trackingSource: trackingSource,
      activeTerm: activeTerm,
      availableTerms: availableTerms,
      hasAnnualDiscount: hasAnnualDiscount
    })
  });
};
export default DetailedTermSelector;